import { ProviderType } from 'features/connections'
import { generateCreateTableFromQuery as generateCreateTableFromQueryForBigQuery } from './bq'
import { generateCreateTableFromQuery as generateCreateTableFromQueryForSnowflake } from './sf'
import { generateCreateTableFromQuery as generateCreateTableFromQueryForRedshift } from './rs'
import { generateCreateTableFromQuery as generateCreateTableFromQueryForPostgres } from './pg'
import { sanitizeSQLSource } from '../../utils'

interface GenerateCreateTableFromQuery {
  provider: ProviderType
  payload: {
    output: string
    query: string
    geoColumn: string
  }
}

export function generateCreateTableFromQuery({ provider, payload }: GenerateCreateTableFromQuery) {
  const sanitizedPayload = { ...payload, query: sanitizeSQLSource(payload.query) }

  switch (provider) {
    case ProviderType.BIGQUERY:
      return generateCreateTableFromQueryForBigQuery(sanitizedPayload)
    case ProviderType.SNOWFLAKE:
      return generateCreateTableFromQueryForSnowflake(sanitizedPayload)
    case ProviderType.REDSHIFT:
      return generateCreateTableFromQueryForRedshift(sanitizedPayload)
    case ProviderType.POSTGRES:
      return generateCreateTableFromQueryForPostgres(sanitizedPayload)
    default:
      throw new Error(`Provider not supported: ${provider}`)
  }
}
